import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthService} from '../auth/services';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, filter, switchMap, take} from 'rxjs/operators';
import {Router} from '@angular/router';
import {Injectable} from '@angular/core';
import { AppConstants } from '../app-constants';
import { environment } from '../../environments/environment';

const API_AUTH_LOGIN_URL = `${environment.apiUrl}/auth/login`;
const API_PUBLIC_URL =`${environment.apiUrl}/v1`;
// Domain hệ thống quản lý gói cước: dùng access_token riêng (không phải token esign)
const PACKAGE_API_URL = environment.packageApiUrl;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this.authService.getAuthFromLocalStorage();

    // Bỏ qua các request tới hệ thống gói cước (package): chúng dùng token riêng,
    // không dùng token đăng nhập esign.
    if (auth && request.url && !request.url.includes(API_PUBLIC_URL) && !this.isPackageUrl(request.url)) {
      // If we have a token, we set it to the header
      request = request.clone({
        setHeaders: {Authorization: `Bearer ${auth.accessToken}`}
      });
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.handle401Error(request, next);
            // if (this.router.url && this.router.url.includes('management')) {
            //   this.router.navigate(['/auth/login'], {
            //     queryParams: {},
            //   });
            // } else {
            //   this.router.navigate(['/'], {
            //     queryParams: {},
            //   });
            // }
          }
        }
        return throwError(err);
      })
    )
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const auth = this.authService.getAuthFromLocalStorage();
      if (auth && auth.refreshToken) {
        return this.authService.refreshToken(auth.refreshToken).pipe(
          switchMap((token: any) => {
            this.isRefreshing = false;

            this.authService.setTokenAuth(token.accessToken);
            this.refreshTokenSubject.next(token.accessToken);
            
            return next.handle(this.addTokenHeader(request, token.accessToken));
          }),
          catchError((err) => {
            this.isRefreshing = false;
            
            // this.tokenService.signOut();
            return throwError(err);
          })
        );
      }
    }

    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    );
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    const auth = this.authService.getAuthFromLocalStorage();

    if (auth && request.url && !request.url.includes(API_PUBLIC_URL) && !this.isPackageUrl(request.url)) {
      return request.clone({
        setHeaders: {Authorization: `Bearer ${token}`}
      });
    }
    return request.clone();
  }

  private isPackageUrl(url: string): boolean {
    return !!url && url.includes(PACKAGE_API_URL);
  }

}
